import { Stack, type Theme, useMediaQuery } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import PageContainer from '/@/components/bayer/page-container';
import EmailVerificationAlert from '/@/components/email-verification-alert';
import settings from '/@/core/settings';
import { useOwnUserNode } from '/@/hooks/nodes';
import { _ } from '/@/locale';
import { getUser } from '/@/store/session/selectors';
import Header from '../../../../components/bayer/header';
import NewFieldGrowersModal from '../../growers/components/new-field-modal';
import UserUIAlertAndModal from '../../rv/components/onboarding-modal-and-alert/user-ui-alert-and-modal';
import GrowerDashboardCurrentCampaign from '../components/dashboard/tabs/current-campaign';
import FieldSection from '../components/field-section';
import RecommendationSection from '../components/recommendation-section';
import ReportsSection from '../components/reports-section';

const GrowerHome = () => {
    const userNodeQuery = useOwnUserNode();
    const growerNode = userNodeQuery.data;
    const isSmOrLower = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
    const [newFieldModalOpen, setNewFieldModalOpen] = useState(false);
    const user = useSelector(getUser)!;

    return (
        <PageContainer
            boxProps={{ sx: { background: '#F5F5F5' } }}
            header={
                <Header
                    title={
                        <>
                            {_('Hola, ')}
                            <span className='mp-mask'>{user?.first_name}</span>
                        </>
                    }
                    subtitle={_('Gestioná tus lotes y seguí cada campaña con recomendaciones personalizadas.')}
                    showSkeleton={userNodeQuery.isValidating}
                />
            }
            boxChildren={
                <>
                    {settings.app.theme === 'expertobayer' && <EmailVerificationAlert />}
                    {growerNode && (
                        <NewFieldGrowersModal
                            open={newFieldModalOpen}
                            setOpen={setNewFieldModalOpen}
                            growerUserNodeId={growerNode?.id}
                            trackEntrySource='grower-dashboard-card'
                        />
                    )}
                </>
            }
        >
            <Stack className='mp-mask' spacing={4}>
                <Stack my={3}>
                    <UserUIAlertAndModal />
                </Stack>
                <Grid2 spacing={3} container mx={{ sm: '-12px !important' }}>
                    <Grid2 xs={12} sm={5} md={6} lg={4} sx={[isSmOrLower && { px: 0 }]}>
                        <FieldSection userNodeId={growerNode?.id} />
                    </Grid2>
                    <Grid2 xs={12} sm={7} md={6} lg={4} sx={[isSmOrLower && { px: 0 }]}>
                        <ReportsSection userNodeId={growerNode?.id} />
                    </Grid2>
                    <Grid2 xs={12} sm={12} md={12} lg={4} sx={[isSmOrLower && { px: 0 }]}>
                        <RecommendationSection userNodeId={growerNode?.id} />
                    </Grid2>
                </Grid2>
                <Stack mt={4}>{growerNode && <GrowerDashboardCurrentCampaign growerNodeId={growerNode.id} />}</Stack>
            </Stack>
        </PageContainer>
    );
};

export default GrowerHome;
